"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapStringFieldProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _RichTextConstants = require("../../RichText/RichTextConstants");

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var configureToolbarButtons = function configureToolbarButtons(newButtons) {
  var buttons = JSON.parse(JSON.stringify(_RichTextConstants.defaultToolbarButtons));
  buttons.moreRich.buttons = buttons.moreRich.buttons.filter(function (item) {
    return item !== "insertImage" && item !== "insertFile";
  });
  buttons.moreRich.buttonsVisible = 4;
  newButtons.forEach(function (newButton) {
    if (buttons.moreRich.buttons.indexOf(newButton) === -1) {
      var newArray = [];
      newArray.push(newButton);
      buttons.moreRich.buttons = newArray.concat(buttons.moreRich.buttons);
    }
  });
  return buttons;
};

var configureToolbarButtonsSM = function configureToolbarButtonsSM(newButtons) {
  var buttons = JSON.parse(JSON.stringify(_RichTextConstants.defaultToolbarButtonsSM));
  buttons.moreRich.buttons = buttons.moreRich.buttons.filter(function (item) {
    return item !== "insertImage" && item !== "insertFile";
  });
  newButtons.forEach(function (newButton) {
    if (buttons.moreRich.buttons.indexOf(newButton) === -1) {
      var newArray = [];
      newArray.push(newButton);
      buttons.moreRich.buttons = newArray.concat(buttons.moreRich.buttons);
    }
  });
  return buttons;
};

var configureToolbarButtonsXS = function configureToolbarButtonsXS(newButtons) {
  var buttons = JSON.parse(JSON.stringify(_RichTextConstants.defaultToolbarButtonsXS));
  buttons.moreRich.buttons = buttons.moreRich.buttons.filter(function (item) {
    return item !== "insertImage" && item !== "insertFile";
  });
  newButtons.forEach(function (newButton) {
    if (buttons.moreRich.buttons.indexOf(newButton) === -1) {
      var newArray = [];
      newArray.push(newButton);
      buttons.moreRich.buttons = newArray.concat(buttons.moreRich.buttons);
    }
  });
  return buttons;
};

var LoadableTextInput = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../TextInput"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableSsnInput = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../SsnInput"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadablePhoneNumberInput = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../PhoneNumberInput"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableDropDown = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../DropDown"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableRadioButtonGroup = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../RadioGroup"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableRichText = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../RichText/RichText"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field, minLength, maxLength) {
  var _field$properties = field.properties,
      isEmail = _field$properties.isEmail,
      isRequired = _field$properties.isRequired,
      disallowSpecialCharacters = _field$properties.disallowSpecialCharacters,
      pattern = _field$properties.pattern;
  var validations = [];

  if (isRequired) {
    validations.push(_Validations.requiredValidation);
  }

  if (pattern) {
    validations.push(_Validations.regExpValidation);
  }

  if (minLength) {
    validations.push(_Validations.minLengthValidation);
  }

  if (maxLength) {
    validations.push(_Validations.maxLengthValidation);
  }

  if (disallowSpecialCharacters) {
    validations.push(_Validations.specialCharactersValidation);
  }

  if (isEmail) {
    validations.push(_Validations.emailValidation);
  }

  return validations;
};

var mapInputProperties = function mapInputProperties(field, model) {
  var _field$properties2 = field.properties,
      minLength = _field$properties2.minLength,
      maxLength = _field$properties2.maxLength;
  var _field$properties3 = field.properties,
      pattern = _field$properties3.pattern,
      patternMessage = _field$properties3.patternMessage;
  minLength = parseInt(minLength, 10);
  maxLength = parseInt(maxLength, 10);
  minLength = isNaN(minLength) ? undefined : minLength;
  maxLength = isNaN(maxLength) ? undefined : maxLength;
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableTextInput,
    regExpPattern: pattern,
    errorMessages: {
      regExpPattern: patternMessage
    },
    minLength: minLength,
    maxLength: maxLength,
    validations: getValidations(field, minLength, maxLength),
    onlyValidateOnBlur: true
  });
};

var mapTextAreaProperties = function mapTextAreaProperties(field, model) {
  return _objectSpread(_objectSpread({}, mapInputProperties(field, model)), {}, {
    multiline: true,
    onlyValidateOnBlur: true,
    rows: 5
  });
};

var mapMaskedInputProperties = function mapMaskedInputProperties(field, model) {
  return _objectSpread(_objectSpread({}, mapInputProperties(field, model)), {}, {
    component: field.properties.mask === "SocialSecurityNumber" ? LoadableSsnInput : LoadablePhoneNumberInput,
    onlyValidateOnBlur: true
  });
};

var mapRichTextProperties = function mapRichTextProperties(field, model, froalaEvents, scrollableContainer, richTextFieldSecondaryHelperText, promptUserForAssetsAsync, customToolbarButtons, customFroalaEditorConfig) {
  var _model$value;

  if (froalaEvents === undefined) {
    froalaEvents = [];
    customToolbarButtons && froalaEvents.push({
      eventName: "imageReplace",
      eventCallback: customToolbarButtons[0].replaceCallback
    });
  }

  var newButtons = promptUserForAssetsAsync ? ["cpDocument", "cpImage"] : customToolbarButtons && customToolbarButtons.map(function (tb) {
    if (!tb.isEditImage) {
      return tb.name;
    }

    return null;
  }).filter(function (x) {
    return x != null;
  }) || [];
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableRichText,
    events: froalaEvents,
    value: (_model$value = model.value) !== null && _model$value !== void 0 ? _model$value : "",
    placeholder: "Insert text here...",
    validations: getValidations(field),
    scrollableContainer: scrollableContainer,
    onlyValidateOnBlur: true,
    config: customFroalaEditorConfig,
    toolbarButtons: configureToolbarButtons(newButtons),
    toolbarButtonsSM: configureToolbarButtonsSM(newButtons),
    toolbarButtonsXS: configureToolbarButtonsXS(newButtons),
    secondaryHelperText: richTextFieldSecondaryHelperText,
    promptUserForAssetsAsync: promptUserForAssetsAsync,
    customToolbarButtons: customToolbarButtons,
    quickInsertEnabled: false,
    toolbarSticky: true
  });
};

var mapRadioProperties = function mapRadioProperties(field, model) {
  return _objectSpread(_objectSpread({}, model), {}, {
    name: model.id,
    component: LoadableRadioButtonGroup,
    options: (0, _FieldMapper.buildOptionArray)(field.properties.allowedValues).map(function (option) {
      return _objectSpread({
        id: "radio-option-".concat(option.value),
        name: "radio-option-".concat(option.value),
        disabled: field.isDisabled
      }, option);
    }),
    validations: getValidations(field),
    onlyValidateOnBlur: true
  });
};

var mapDropdownProperties = function mapDropdownProperties(field, model) {
  var properties = field.properties;
  var options;

  if (properties.allowedValuesWithLabels) {
    options = (0, _FieldMapper.buildOptionsArrayWithLabels)(properties.allowedValuesWithLabels);
  } else {
    options = (0, _FieldMapper.buildOptionArray)(properties.allowedValues);
  }

  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableDropDown,
    options: options,
    validations: getValidations(field),
    onlyValidateOnBlur: true,
    value: options.find(function (x) {
      return x.value === model.value;
    }),
    // react-select doesn't return an event, it just returns an array of selected values.
    // So we give dropdown a unique onChange, and always return the first element because it should only have 1.
    onChange: function onChange(selected) {
      var value = selected[0];
      return value != null ? value : {
        value: null
      };
    }
  });
};

var mapStringFieldProperties = function mapStringFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      value = _ref.value,
      froalaEvents = _ref.froalaEvents,
      scrollableContainer = _ref.scrollableContainer,
      richTextFieldSecondaryHelperText = _ref.richTextFieldSecondaryHelperText,
      promptUserForAssetsAsync = _ref.promptUserForAssetsAsync,
      customToolbarButtons = _ref.customToolbarButtons,
      customFroalaEditorConfig = _ref.customFroalaEditorConfig,
      onBlur = _ref.onBlur,
      onValidation = _ref.onValidation;
  var model = (0, _FieldMapper.default)(field, htmlId, value, onBlur, onValidation);

  switch (field.properties.editor) {
    case "TextArea":
      return mapTextAreaProperties(field, model);

    case "MaskedInput":
      return mapMaskedInputProperties(field, model);

    case "Input":
      return mapInputProperties(field, model);

    case "Dropdown":
      return mapDropdownProperties(field, model);

    case "RichText":
      return mapRichTextProperties(field, model, froalaEvents, scrollableContainer, richTextFieldSecondaryHelperText, promptUserForAssetsAsync, customToolbarButtons, customFroalaEditorConfig);

    case "Radio":
      return mapRadioProperties(field, model);

    default:
      return model;
  }
};

exports.mapStringFieldProperties = mapStringFieldProperties;
var _default = mapStringFieldProperties;
exports.default = _default;